import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const preloadImage = (src: string) => {
  const img = new Image();
  img.src = src;
};

export const preloadAssets = () => {
  import('../assets/flags/catalonia.png').then((src) => preloadImage(src.default));
  import('../assets/flags/china.png').then((src) => preloadImage(src.default));
  import('../assets/flags/euskera.png').then((src) => preloadImage(src.default));
  import('../assets/flags/france.png').then((src) => preloadImage(src.default));
  import('../assets/flags/germany.png').then((src) => preloadImage(src.default));
  import('../assets/flags/gl.png').then((src) => preloadImage(src.default));
  import('../assets/flags/italy.png').then((src) => preloadImage(src.default));
  import('../assets/flags/japan.png').then((src) => preloadImage(src.default));
  import('../assets/flags/portugal.png').then((src) => preloadImage(src.default));
  import('../assets/flags/russia.png').then((src) => preloadImage(src.default));
  import('../assets/flags/saudiarabia.png').then((src) => preloadImage(src.default));
  import('../assets/flags/spain.png').then((src) => preloadImage(src.default));
  import('../assets/flags/usa.png').then((src) => preloadImage(src.default));

  import('../assets/damelio_logo_blanco.png').then((src) => preloadImage(src.default));
  import('../assets/damelio_logo_negro.png').then((src) => preloadImage(src.default));
  import('../assets/damelio_texto_blanco.png').then((src) => preloadImage(src.default));
  import('../assets/damelio_texto_negro.png').then((src) => preloadImage(src.default));
};